import moment from "moment";
import yup from "./yup.Module";

// export const yupMomentDataHoraValidator = (
//   fieldName: string,
//   format: string = ""
// ) =>
//   yup
//     .mixed<moment.Moment>()
//     .required(`${fieldName} é obrigatório.`)
//     .transform((value) => {
//       if (moment.isMoment(value)) return value;
//       if (!value) return value;

//       const raw = String(value).trim();

//       const formats = [
//         moment.ISO_8601,
//         "YYYY-MM-DDTHH:mm:ss",
//         "YYYY-MM-DDTHH:mm",
//         "DD/MM/YYYY HH:mm:ss",
//         "DD/MM/YYYY HH:mm",
//         "DD/MM/YYYY",
//       ];

//       let d = moment(raw, format ? format : formats, true);

//       if (!d.isValid()) {
//         return moment.invalid();
//       }

//       if (raw.length === 16) {
//         d = d.seconds(0);
//       }

//       return d;
//     })
//     .test("is-valid-moment", `${fieldName} é inválido.`, (value) => {
//       return moment.isMoment(value) && value.isValid();
//     });

export const yupDataValidator = (
  fieldName: string,
  format: string,
  required: boolean = true
) =>
  yup
    .string()
    .nullable()
    .transform((value) => {
      if (!value || value === "") return null;

      const raw = String(value).trim();

      const formatList = [format];

      let d = moment(raw, formatList, true);

      if (!d.isValid()) return null;

      if (raw.length === 16) {
        d = d.seconds(0);
      }

      return d.format(format);
    })
    .test(
      "is-valid-date",
      `${fieldName} ${required ? "é obrigatório e" : "é"} inválido.`,
      (value) => {
        if (required) {
          return (
            value != null &&
            moment(value, format || "DD/MM/YYYY HH:mm:ss", true).isValid()
          );
        }
        return (
          value === null || moment(value, "DD/MM/YYYY HH:mm:ss", true).isValid()
        );
      }
    );
